var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



// WEBPACK FOOTER //
// D:/a/vallentuna-public/vallentuna-public/node_modules/core-js/modules/_cof.js